import { SofiaChatMessage } from "@/modules/chats/types/chat-message"

type ChatSystemMessageProps = {
  message: SofiaChatMessage
}
const ChatSystemMessage = (props: ChatSystemMessageProps) => {
  const { message } = props

  return (
    <div className="animate-fade-in-bottom flex min-h-8.5 items-center justify-center gap-2 transition-all">
      <span className="text-on-surface-subdue text-center text-xs">{message.content}</span>
    </div>
  )
}

export { ChatSystemMessage }
